
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { uiInfoText } from "@/helpers/ui-info-text";

@Component
export default class KraalSelectInput extends Vue {
  @Model("input", { type: String }) readonly value!: string;
  @Prop({ type: Array, default: () => [] }) readonly kraalIds!: string[];
  @Prop({ type: String, default: "Kraal" }) readonly label!: string;
  @Prop({ type: Boolean, default: true }) readonly isRequired!: boolean;
  @Prop({ type: String, default: "Select Kraal" }) readonly dialogTitle!: string;
  @Prop({ type: String, default: "" }) readonly displayLabel!: string;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: [String, Number], default: 640 }) readonly maxWidth!: string | number;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showInfoIcon!: boolean;
  @Prop({ type: String, default: "" }) readonly infoTitle!: string;
  @Prop({ type: Array, default: () => [] }) readonly infoBullets!: string[];

  dialog: boolean = false;
  draft: string = "";
  searchInput: string = "";

  get filteredKraalIds() {
    const term = this.searchInput.toLowerCase();
    if (!term) return this.kraalIds;
    return this.kraalIds.filter((id) => id.toLowerCase().includes(term));
  }

  openDialog() {
    if (this.isLocked) {
      return;
    }

    this.draft = this.value || "";
    this.searchInput = "";
    this.dialog = true;
    this.$nextTick(() => requestAnimationFrame(() => (this.$refs.kraalSearchInput as any)?.focus()));
  }

  openInfoDialog() {
    const title = this.infoTitle || this.label;
    const info = uiInfoText[title as keyof typeof uiInfoText];
    this.$store.commit("popup/displayOk", {
      title,
      bullets: this.infoBullets.length ? this.infoBullets : info ? info.bullets : ["No info available"],
    });
  }

  closeDialog() {
    this.dialog = false;
    this.searchInput = "";
  }

  @Watch("dialog")
  onDialogChanged(nextValue: boolean, previousValue: boolean) {
    if (previousValue && !nextValue) {
      this.$nextTick(() => requestAnimationFrame(() => (document.activeElement as HTMLElement | null)?.blur()));
    }
  }

  clearSelection() {
    this.draft = "";
  }

  selectKraal(id: string) {
    this.draft = id;
  }

  save() {
    this.$emit("input", this.draft);
    this.closeDialog();
  }
}
